module.exports = __webpack_public_path__ + "static/how-the-scots-invented-the-modern-world-70a25adb4bbf53b8121cb2e8d415c933.jpg";